/* EYESHELLS floating controls coordinated utility runtime v1751 */
(function (window, document) {
  'use strict';

  if (window.__esFloatingControlsCleanup) {
    try { window.__esFloatingControlsCleanup(); } catch (_cleanupError) {}
  }

  var root = document.documentElement;
  var body = document.body;
  var backToTop = document.getElementById('back-to-top');
  if (!root || !body) return;

  var CHAT_HOST_SELECTOR = [
    'inbox-online-store-chat',
    'shopify-chat',
    'shopify-inbox',
    'shopify-inbox-chat',
    '#shopify-chat',
    '#ShopifyChat',
    '#ShopifyInbox',
    '#ShopifyInboxLauncher',
    '#shopify-chat-dummy',
    '#dummy-chat-button-iframe',
    '.shopify-chat',
    '.shopify-inbox__launcher',
    '.ShopifyInbox__launcher',
    '.ShopifyInboxLauncher',
    '[data-shopify-chat]',
    '[data-shopify-inbox]',
    '[data-inbox-launcher]',
    '[id*="shopify-chat" i]',
    '[id*="shopify-inbox" i]',
    'iframe[src*="chat.shopify" i]',
    'iframe[src*="inbox" i]',
    'iframe[title*="chat" i]',
    'iframe[title*="inbox" i]'
  ].join(',');

  var CHAT_LAUNCHER_SELECTOR = [
    'button.chat-toggle',
    '.chat-toggle[role="button"]',
    'button[aria-label*="chat" i]',
    'button[aria-label*="message" i]',
    'button[title*="chat" i]',
    '[role="button"][aria-label*="chat" i]',
    '[role="button"][aria-label*="message" i]'
  ].join(',');

  var SUPPRESSION_CLASSES = [
    'es-qv-open',
    'es-lb-open',
    'es-tryon-clean-open',
    'es-size-guide-open',
    'es-size-guide-open-mobile',
    'es-mobile-filters-open',
    'es-mobile-sort-sheet-active',
    'es-search-modal-open',
    'es-search-open',
    'activemenu_mobile'
  ];

  var SHADOW_GLASS_CSS = "[data-es-chat-glass=\"true\"],\n[part~=\"activator\"]{\n  --activator-fg:#111 !important;\n  --activator-bg:#fff !important;\n  border:1px solid rgba(17,17,17,.16) !important;\n  border-radius:16px !important;\n  min-height:44px !important;\n  height:44px !important;\n  padding:0 14px !important;\n  gap:8px !important;\n  font-size:14px !important;\n  box-sizing:border-box !important;\n  background:#fff !important;\n  color:#111 !important;\n  -webkit-text-fill-color:currentColor !important;\n  background-clip:padding-box !important;\n  box-shadow:0 3px 12px rgba(17,17,17,.10) !important;\n  -webkit-backdrop-filter:none !important;\n  backdrop-filter:none !important;\n  transition:border-color .18s ease,box-shadow .18s ease !important;\n}\n[data-es-chat-glass=\"true\"] .activator__label,\n[data-es-chat-glass=\"true\"] .activator__label *,\n[data-es-chat-glass=\"true\"] .activator__icon{\n  color:#111 !important;\n  -webkit-text-fill-color:currentColor !important;\n  opacity:1 !important;\n}\n@media (hover:hover) and (pointer:fine){\n  [data-es-chat-glass=\"true\"]:hover,\n  [part~=\"activator\"]:hover{\n    border-color:rgba(17,17,17,.28) !important;\n    box-shadow:0 4px 14px rgba(17,17,17,.14) !important;\n  }\n}\n[data-es-chat-glass=\"true\"]:focus-visible,\n[part~=\"activator\"]:focus-visible{outline:2px solid #111 !important;outline-offset:3px !important;}\n@media (prefers-reduced-motion:reduce){\n  [data-es-chat-glass=\"true\"],\n  [part~=\"activator\"]{transition:none !important;}\n}\n";

  var destroyed = false;
  var stateRaf = 0;
  var visibilityRaf = 0;
  var reducedMotion = false;

  var bodyObserver = null;
  var classObserver = null;

  var chatHosts = [];
  var chatRoots = [];
  var upgradeTags = [];
  var startupTimers = [];
  var hostObservers = [];
  var shadowObservers = [];
  var observedShadowRoots = [];
  var injectedShadowStyles = [];

  var visualSurface = null;
  var activeLauncher = null;
  var launcherResizeObserver = null;
  var measuredLauncher = null;
  var chatStructureDirty = true;

  function ensureBackToTopPortal() {
    if (!backToTop || backToTop.parentNode === body) return;
    try { body.appendChild(backToTop); } catch (_error) {}
  }

  function readReducedMotion() {
    try { reducedMotion = !!window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    catch (_error) { reducedMotion = false; }
  }

  function getRect(element) {
    try { return element && element.getBoundingClientRect ? element.getBoundingClientRect() : null; }
    catch (_error) { return null; }
  }

  function getStyle(element) {
    try { return element ? window.getComputedStyle(element) : null; }
    catch (_error) { return null; }
  }

  function isVisible(element) {
    if (!element || !element.isConnected) return false;
    var style = getStyle(element);
    if (!style || style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity || '1') <= 0) return false;
    var rect = getRect(element);
    return !!(rect && rect.width >= 2 && rect.height >= 2 && rect.right > 0 && rect.bottom > 0 && rect.left < window.innerWidth && rect.top < window.innerHeight);
  }

  function observeShadowRoot(shadowRoot) {
    if (!window.MutationObserver || !shadowRoot || observedShadowRoots.indexOf(shadowRoot) !== -1) return;
    var observer = new MutationObserver(function(mutations){
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].type === 'childList') chatStructureDirty = true;
      }
      scheduleStateSync();
    });
    try {
      observer.observe(shadowRoot, {
        childList:true,
        subtree:true,
        attributes:true,
        attributeFilter:['class','hidden','aria-hidden','aria-expanded','aria-modal','is-open','open','part']
      });
      observedShadowRoots.push(shadowRoot);
      shadowObservers.push(observer);
    } catch (_error) {
      try { observer.disconnect(); } catch (_disconnectError) {}
    }
  }

  function collectOpenShadowRoots(host, roots, depth) {
    if (!host || depth > 1) return;
    var shadowRoot = null;
    try { shadowRoot = host.shadowRoot; } catch (_error) {}
    if (!shadowRoot || roots.indexOf(shadowRoot) !== -1) return;
    roots.push(shadowRoot);
    observeShadowRoot(shadowRoot);

    var nested = [];
    try { nested = shadowRoot.querySelectorAll('*'); } catch (_queryError) {}
    for (var i = 0; i < nested.length; i += 1) {
      if (nested[i].shadowRoot) collectOpenShadowRoots(nested[i], roots, depth + 1);
    }
  }

  function disconnectHostObservers() {
    for (var i = 0; i < hostObservers.length; i += 1) {
      try { hostObservers[i].disconnect(); } catch (_error) {}
    }
    hostObservers.length = 0;
  }

  function observeHosts() {
    disconnectHostObservers();
    if (!window.MutationObserver) return;
    for (var i = 0; i < chatHosts.length; i += 1) {
      var observer = new MutationObserver(function(){ chatStructureDirty = true; scheduleStateSync(); });
      try {
        observer.observe(chatHosts[i], {
          attributes:true,
          childList:true,
          attributeFilter:['class','style','hidden','aria-hidden','aria-expanded','aria-modal','is-open','open']
        });
        hostObservers.push(observer);
      } catch (_error) {
        try { observer.disconnect(); } catch (_disconnectError) {}
      }
    }
  }

  function sameElements(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i += 1) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  function refreshChatRoots() {
    var hosts = chatHosts;
    if (chatStructureDirty || chatHosts.some(function(host){ return !host.isConnected; })) {
      try { hosts = Array.prototype.slice.call(document.querySelectorAll(CHAT_HOST_SELECTOR)).filter(function(host){ return !/^(script|style|link|template)$/i.test(host.tagName); }); }
      catch (_error) { hosts = []; }
    }

    if (!sameElements(hosts, chatHosts)) {
      for (var oldIndex = 0; oldIndex < chatHosts.length; oldIndex += 1) {
        try { chatHosts[oldIndex].removeAttribute('data-es-chat-root'); } catch (_removeError) {}
      }
      chatHosts = hosts;
      observeHosts();
    }

    var roots = [];
    for (var i = 0; i < chatHosts.length; i += 1) {
      try { chatHosts[i].setAttribute('data-es-chat-root', 'true'); } catch (_markError) {}
      roots.push(chatHosts[i]);
      collectOpenShadowRoots(chatHosts[i], roots, 0);
      var tag = String(chatHosts[i].localName || '');
      if (tag.indexOf('-') !== -1 && window.customElements && upgradeTags.indexOf(tag) === -1) {
        upgradeTags.push(tag);
        window.customElements.whenDefined(tag).then(function(){ chatStructureDirty = true; scheduleStateSync(); });
      }
    }
    for (var stale = observedShadowRoots.length - 1; stale >= 0; stale -= 1) {
      if (roots.indexOf(observedShadowRoots[stale]) !== -1) continue;
      try { shadowObservers[stale].disconnect(); } catch (_error) {}
      observedShadowRoots.splice(stale, 1);
      shadowObservers.splice(stale, 1);
    }
    injectedShadowStyles = injectedShadowStyles.filter(function(style){ return style.isConnected; });
    chatRoots = roots;
    chatStructureDirty = false;
  }

  function launcherMetrics(element) {
    if (!isVisible(element)) return null;
    var rect = getRect(element);
    if (!rect || rect.width < 28 || rect.height < 28 || rect.width > 320 || rect.height > 190) return null;
    return {
      element:element,
      rect:rect,
      rightDistance:Math.max(0, window.innerWidth - rect.right),
      bottomDistance:Math.max(0, window.innerHeight - rect.bottom),
      area:rect.width * rect.height
    };
  }

  function findLauncher() {
    for (var nativeIndex = 0; nativeIndex < chatRoots.length; nativeIndex += 1) {
      var nativeLauncher = chatRoots[nativeIndex].querySelector('button[part~="activator"]');
      if (nativeLauncher && nativeLauncher.isConnected) {
        activeLauncher = nativeLauncher;
        return nativeLauncher;
      }
    }

    var candidates = [];
    var seen = [];

    function addCandidate(element) {
      if (!element || seen.indexOf(element) !== -1) return;
      var metrics = launcherMetrics(element);
      if (!metrics) return;
      seen.push(element);
      candidates.push(metrics);
    }

    for (var r = 0; r < chatRoots.length; r += 1) {
      var controls = [];
      try { controls = chatRoots[r].querySelectorAll(CHAT_LAUNCHER_SELECTOR); } catch (_error) {}
      if (chatRoots[r].matches && chatRoots[r].matches(CHAT_LAUNCHER_SELECTOR)) addCandidate(chatRoots[r]);
      for (var c = 0; c < controls.length; c += 1) {
        var label = String(controls[c].getAttribute('aria-label') || controls[c].getAttribute('title') || '').trim();
        if (/^(?:close|expand|collapse|new|create|back|send|sign)\b/i.test(label)) continue;
        addCandidate(controls[c]);
      }
    }

    if (!candidates.length) return null;

    candidates.sort(function (a, b) {
      var aEdge = a.rightDistance + a.bottomDistance;
      var bEdge = b.rightDistance + b.bottomDistance;
      if (aEdge !== bEdge) return aEdge - bEdge;
      return b.area - a.area;
    });

    var nearest = candidates[0];
    var group = candidates.filter(function (candidate) {
      return candidate.rightDistance <= nearest.rightDistance + 28
        && candidate.bottomDistance <= nearest.bottomDistance + 28;
    });

    group.sort(function (a, b) {
      if (a.area !== b.area) return b.area - a.area;
      return (a.rightDistance + a.bottomDistance) - (b.rightDistance + b.bottomDistance);
    });

    activeLauncher = group[0].element;
    return activeLauncher;
  }

  function injectGlassStyleFor(element) {
    if (!element || !element.getRootNode) return;
    var treeRoot = null;
    try { treeRoot = element.getRootNode(); } catch (_error) {}
    if (!treeRoot || treeRoot === document || treeRoot.nodeType !== 11) return;
    try {
      if (treeRoot.querySelector('style[data-es-chat-glass-style]')) return;
      var style = document.createElement('style');
      style.setAttribute('data-es-chat-glass-style', 'true');
      style.textContent = SHADOW_GLASS_CSS;
      treeRoot.appendChild(style);
      injectedShadowStyles.push(style);
    } catch (_injectError) {}
  }

  function clearGlassSurface() {
    if (!visualSurface) return;
    try {
      visualSurface.removeAttribute('data-es-chat-glass');
      /* Remove the legacy dynamic radius left by older theme versions. */
      visualSurface.style.removeProperty('--es-chat-glass-radius');
    } catch (_error) {}
    visualSurface = null;
  }

  function applyGlassSurface(launcher) {
    if (!launcher || String(launcher.tagName || '').toLowerCase() === 'iframe') {
      clearGlassSurface();
      return;
    }

    /* The launcher button itself is the only glass target. Do not walk up and
       down Shopify's changing wrapper tree, and never derive radius from its
       transient dimensions. */
    if (launcher !== visualSurface) clearGlassSurface();
    visualSurface = launcher;

    try {
      visualSurface.style.removeProperty('--es-chat-glass-radius');
      if (visualSurface.getAttribute('data-es-chat-glass') !== 'true') visualSurface.setAttribute('data-es-chat-glass', 'true');
      injectGlassStyleFor(visualSurface);
    } catch (_error) {}
  }

  function hostLooksOpen(host) {
    if (!host || !host.isConnected) return false;
    try {
      if (host.hasAttribute('open')) return true;
      if (host.getAttribute('is-open') === 'true') return true;
      if (host.getAttribute('aria-expanded') === 'true') return true;
      if (host.getAttribute('aria-modal') === 'true') return true;
      if (/(?:^|\s)(?:open|active|expanded)(?:\s|$)/i.test(String(host.className || ''))) {
        var openRect = getRect(host);
        if (openRect && openRect.width >= 240 && openRect.height >= 200) return true;
      }
    } catch (_error) {}
    return false;
  }

  function chatPanelOpen() {
    for (var h = 0; h < chatHosts.length; h += 1) {
      if (hostLooksOpen(chatHosts[h])) return true;
      if (isVisible(chatHosts[h])) {
        var hostRect = getRect(chatHosts[h]);
        var hostTag = String(chatHosts[h].tagName || '').toLowerCase();
        if (hostTag === 'iframe' && hostRect && hostRect.width >= 260 && hostRect.height >= 220) return true;
      }
    }

    for (var r = 0; r < chatRoots.length; r += 1) {
      var dialogs = [];
      try { dialogs = chatRoots[r].querySelectorAll('[role="dialog"],[aria-modal="true"]'); } catch (_error) {}
      for (var d = 0; d < dialogs.length; d += 1) {
        if (!isVisible(dialogs[d])) continue;
        var rect = getRect(dialogs[d]);
        if (rect && rect.width >= 240 && rect.height >= 200) return true;
      }
    }
    return false;
  }

  function componentModalOpen() {
    for (var i = 0; i < SUPPRESSION_CLASSES.length; i += 1) {
      if (root.classList.contains(SUPPRESSION_CLASSES[i]) || body.classList.contains(SUPPRESSION_CLASSES[i])) return true;
    }
    return false;
  }

  function setSuppressionState(panelOpen, modalOpen) {
    root.setAttribute('data-es-chat-panel-open', panelOpen ? 'true' : 'false');
    root.setAttribute('data-es-modal-suppressed', modalOpen ? 'true' : 'false');
    root.setAttribute('data-es-floating-suppressed', panelOpen || modalOpen ? 'true' : 'false');
  }


  function isMobileCartPage() {
    return body.classList.contains('template-cart') && window.innerWidth <= 767.98;
  }

  /* Mobile cart visibility is CSS-owned via body.template-cart. The runtime only
     exposes the state attribute for back-to-top visibility; it never mutates
     Shopify Inbox inline styles. */

  function visibilityThreshold() {
    return Math.max(320, Math.min(560, Math.round(window.innerHeight * .55)));
  }

  function setBackToTopVisible(visible) {
    if (!backToTop || backToTop.classList.contains('show') === visible) return;
    backToTop.classList.toggle('show', visible);
    backToTop.setAttribute('aria-hidden', visible ? 'false' : 'true');
    backToTop.tabIndex = visible ? 0 : -1;
  }

  function updateVisibility() {
    var y = window.pageYOffset || root.scrollTop || body.scrollTop || 0;
    var suppressed = root.getAttribute('data-es-floating-suppressed') === 'true'
      || root.getAttribute('data-es-mobile-cart-floats-hidden') === 'true';
    setBackToTopVisible(y > visibilityThreshold() && !suppressed);
  }

  function alignBackToTop(launcher, suppressed) {
    if (launcher !== measuredLauncher) {
      if (launcherResizeObserver) launcherResizeObserver.disconnect();
      launcherResizeObserver = null;
      measuredLauncher = launcher;
      if (launcher && window.ResizeObserver) {
        launcherResizeObserver = new window.ResizeObserver(scheduleStateSync);
        launcherResizeObserver.observe(launcher);
      }
    }
    if (!backToTop) return;
    if (!launcher) {
      backToTop.style.removeProperty('--es-btt-right');
      backToTop.style.removeProperty('--es-btt-bottom');
      return;
    }
    if (suppressed) return;
    var metrics = launcherMetrics(launcher);
    if (!metrics) return;
    var rect = metrics.rect;
    var style = getStyle(backToTop);
    var size = parseFloat(style && style.getPropertyValue('--es-btt-size')) || 40;
    var gap = parseFloat(style && style.getPropertyValue('--es-float-gap')) || 10;
    // Fixed right uses the layout viewport, excluding the vertical scrollbar.
    // Measure only on app/size changes, never on ordinary page scrolling.
    var right = Math.max(0, (root.clientWidth || window.innerWidth) - rect.left - rect.width / 2 - size / 2);
    var bottom = Math.max(0, (root.clientHeight || window.innerHeight) - rect.top + gap);
    [['--es-btt-right', right], ['--es-btt-bottom', bottom]].forEach(function (entry) {
      var value = (Math.round(entry[1] * 100) / 100) + 'px';
      if (backToTop.style.getPropertyValue(entry[0]) !== value) backToTop.style.setProperty(entry[0], value);
    });
  }

  function syncState() {
    if (destroyed) return;
    ensureBackToTopPortal();
    refreshChatRoots();

    var launcher = findLauncher();
    var panelOpen = chatPanelOpen();
    var modalOpen = componentModalOpen();
    var mobileCartHidden = isMobileCartPage();

    if (mobileCartHidden) root.setAttribute('data-es-mobile-cart-floats-hidden', 'true');
    else root.removeAttribute('data-es-mobile-cart-floats-hidden');
    if (chatHosts.length) root.setAttribute('data-es-chat-present', 'true');
    else root.removeAttribute('data-es-chat-present');
    setSuppressionState(panelOpen, modalOpen);

    /* Keep the appearance installed while native/theme CSS hides the widget.
       Loading/open/close must not switch back to Shopify's inverted palette. */
    applyGlassSurface(launcher);
    alignBackToTop(launcher, panelOpen || modalOpen || mobileCartHidden);

    updateVisibility();
  }

  function scheduleStateSync() {
    if (destroyed || stateRaf) return;
    stateRaf = window.requestAnimationFrame(function () {
      stateRaf = 0;
      try { syncState(); }
      catch (error) {
        try { if (typeof window.ESDebug === 'function') window.ESDebug('floating-controls', error); }
        catch (_debugError) {}
      }
    });
  }

  function scheduleVisibility() {
    if (destroyed || visibilityRaf) return;
    visibilityRaf = window.requestAnimationFrame(function () {
      visibilityRaf = 0;
      updateVisibility();
    });
  }

  function focusTopTarget() {
    var target = document.querySelector('#MainContent,main,h1,#header');
    if (!target || !target.isConnected) return;
    var hadTabindex = target.hasAttribute('tabindex');
    var oldTabindex = target.getAttribute('tabindex');
    if (!hadTabindex) target.setAttribute('tabindex', '-1');
    try { target.focus({ preventScroll:true }); }
    catch (_error) { try { target.focus(); } catch (_focusError) {} }
    if (!hadTabindex) {
      target.addEventListener('blur', function cleanupTabindex() {
        target.removeEventListener('blur', cleanupTabindex);
        target.removeAttribute('tabindex');
      }, { once:true });
    } else if (oldTabindex !== null) {
      target.setAttribute('tabindex', oldTabindex);
    }
  }

  function onBackToTop(event) {
    event.preventDefault();
    readReducedMotion();
    try { window.scrollTo({ top:0, left:0, behavior:reducedMotion ? 'auto' : 'smooth' }); }
    catch (_error) { window.scrollTo(0, 0); }
    window.setTimeout(function () {
      updateVisibility();
      focusTopTarget();
    }, reducedMotion ? 0 : 420);
  }

  function onPageShow() {
    if (destroyed) return;
    scheduleStateSync();
  }

  function onPageHide(event) {
    if (event && event.persisted) return;
    cleanup();
  }

  function onVisibilityChange() {
    if (document.visibilityState !== 'hidden') scheduleStateSync();
  }

  function cleanup() {
    if (destroyed) return;
    destroyed = true;

    clearGlassSurface();
    disconnectHostObservers();
    if (launcherResizeObserver) launcherResizeObserver.disconnect();
    launcherResizeObserver = null;
    measuredLauncher = null;

    if (stateRaf) window.cancelAnimationFrame(stateRaf);
    if (visibilityRaf) window.cancelAnimationFrame(visibilityRaf);
    if (bodyObserver) bodyObserver.disconnect();
    if (classObserver) classObserver.disconnect();

    for (var i = 0; i < shadowObservers.length; i += 1) {
      try { shadowObservers[i].disconnect(); } catch (_shadowError) {}
    }
    for (var j = 0; j < injectedShadowStyles.length; j += 1) {
      try { injectedShadowStyles[j].remove(); } catch (_styleError) {}
    }
    for (var h = 0; h < chatHosts.length; h += 1) {
      try {
        chatHosts[h].removeAttribute('data-es-chat-root');
      } catch (_hostError) {}
    }

    shadowObservers.length = 0;
    observedShadowRoots.length = 0;
    injectedShadowStyles.length = 0;
    chatHosts.length = 0;
    chatRoots = [];
    activeLauncher = null;
    chatStructureDirty = true;

    window.removeEventListener('scroll', scheduleVisibility);
    window.removeEventListener('resize', scheduleStateSync);
    window.removeEventListener('orientationchange', scheduleStateSync);
    window.removeEventListener('pageshow', onPageShow);
    window.removeEventListener('pagehide', onPageHide);
    document.removeEventListener('visibilitychange', onVisibilityChange);
    document.removeEventListener('shopify:section:load', scheduleStateSync);
    if (backToTop) backToTop.removeEventListener('click', onBackToTop);
    startupTimers.forEach(function(timer){ window.clearTimeout(timer); });
    startupTimers.length = 0;

    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', scheduleStateSync);
    }

    root.removeAttribute('data-es-chat-present');
    root.removeAttribute('data-es-chat-panel-open');
    root.removeAttribute('data-es-modal-suppressed');
    root.removeAttribute('data-es-floating-suppressed');
    root.removeAttribute('data-es-mobile-cart-floats-hidden');
    if (backToTop) {
      backToTop.style.removeProperty('--es-btt-right');
      backToTop.style.removeProperty('--es-btt-bottom');
      backToTop.classList.remove('show');
      backToTop.setAttribute('aria-hidden', 'true');
      backToTop.tabIndex = -1;
    }
  }

  readReducedMotion();
  ensureBackToTopPortal();
  if (backToTop) backToTop.addEventListener('click', onBackToTop);
  window.addEventListener('scroll', scheduleVisibility, { passive:true });
  window.addEventListener('resize', scheduleStateSync, { passive:true });
  window.addEventListener('orientationchange', scheduleStateSync, { passive:true });
  window.addEventListener('pageshow', onPageShow, { passive:true });
  window.addEventListener('pagehide', onPageHide);
  document.addEventListener('visibilitychange', onVisibilityChange);
  document.addEventListener('shopify:section:load', scheduleStateSync);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleStateSync, { passive:true });
  }

  if (window.MutationObserver) {
    function containsChatHost(node) {
      if (!node || node.nodeType !== 1 || /^(script|style|link|template)$/i.test(node.tagName)) return false;
      return (node.matches && node.matches(CHAT_HOST_SELECTOR)) ||
        (node.querySelector && node.querySelector(CHAT_HOST_SELECTOR));
    }
    bodyObserver = new MutationObserver(function(mutations){
      for (var i = 0; i < mutations.length; i += 1) {
        var nodes = Array.prototype.slice.call(mutations[i].addedNodes).concat(Array.prototype.slice.call(mutations[i].removedNodes));
        if (nodes.some(containsChatHost)) {
          chatStructureDirty = true;
          scheduleStateSync();
          return;
        }
      }
    });
    bodyObserver.observe(body, { childList:true, subtree:true });

    classObserver = new MutationObserver(scheduleStateSync);
    classObserver.observe(root, { attributes:true, attributeFilter:['class'] });
    classObserver.observe(body, { attributes:true, attributeFilter:['class'] });
  }

  window.__esFloatingControlsCleanup = cleanup;
  syncState();
  /* Bounded discovery for app embeds that attach their shadow tree after mount. */
  [100, 350, 1000, 2500].forEach(function(delay){
    startupTimers.push(window.setTimeout(scheduleStateSync, delay));
  });
})(window, document);
